import { useNavigate } from 'react-router-dom';
import { env } from '../env';
import { useAuth } from '@/Bridges/GLUtils';
import { IMPERSONATE_KEY } from '@/Constants/keys';

interface CallbackToModalLogout {
  callbackFnToModalLogout: () => void;
}

export function useCallbackToModalLogout(): CallbackToModalLogout {
  const navigate = useNavigate();
  const { clear } = useAuth();

  function callbackFnToModalLogout(): void {
    localStorage.removeItem(`@utilities-${env.VITE_NODE_ENV}`);

    navigate('/login');
    localStorage.removeItem(IMPERSONATE_KEY);

    clear();
  }

  return {
    callbackFnToModalLogout,
  };
}
